/**
 * теперь этот файл/поток будет кодироваться в UTF-8
 */

export const CustomSelect = {
    props: {
        modelValue: {
            type: String
        },
        options: Array
    },
    data () {
        return {
            selected: this.modelValue,
            selectedShow: this.modelValue,
            open: false,
        }
    },
    methods: {
        selectItems(option) {

            this.selected = option.id;
            this.selectedShow = option.name;
            this.open = false;
            this.$emit('update:modelValue', this.selected);
        }
    },
    mounted() {

        this.$emit("update:modelValue", this.selected);
    },
    template: `
      <div class="custom-select">
        <div class="selected" :class="{ open: open }" @click="open = !open">
          {{ selectedShow }}
          <svg :class="{
            'custom-select__rotate':open 
          }" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="custom-select__icon">
            <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
          </svg>

        </div>
        <div class="items" :class="{ selectHide: !open }">
          <div
              v-for="(option, i) of options"
              :key="i"
              @click="selectItems(option)"
          >
            {{ option.name }}
          </div>
        </div>
      </div>
        `,
};
